import Typography, {
  TypographyPropsVariantOverrides,
  TypographyProps,
} from '@mui/material/Typography';
import { OverridableStringUnion } from '@mui/types';
import { TypographyVariant } from '../styles';

export type Props = TypographyProps;
export type Variant = OverridableStringUnion<
  TypographyVariant | 'inherit',
  TypographyPropsVariantOverrides
>;
export default Typography;
